import axios from 'axios';

const staticClient = axios.create({
  baseURL: `${process.env.VUE_APP_STATIC_BASE_URL}${process.env.VUE_APP_STAGE}/`,
  headers: { 'Content-Type': 'application/json' },
});

export default staticClient;
